import {
  INVESTORS_FETCH_REQUESTED,
  INVESTORS_FETCHED,
  INVESTOR_FETCHED,
} from 'utils/constants'
import { reduce } from 'lodash';

export default (state = {}, action) => {
  switch (action.type) {
    case INVESTOR_FETCHED: {
      const { investors } = state;
      const { investor } = action.data;
      return {
        ...state,
        fetching: false,
        investors: { ...investors, [investor.id]: investor }
      };
    }
    case INVESTORS_FETCH_REQUESTED:
      return { ...state, fetching: true };
    case INVESTORS_FETCHED:
      const investors = reduce(action.data.investors, (obj, investor) => {
        obj[investor.id] = investor
        return obj
      }, {});
      return { ...state, fetching: false, investors };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/investors.js